import Navbar from "./NavigationBar/Nav";
import Footer from "./Footer/Footer";
import { Outlet, ScrollRestoration } from "react-router-dom";

export default function Layout() {
  return (
    <>
      <Navbar />
      <Outlet />
      <ScrollRestoration />
      <Footer />
    </>
  );
}
